module.exports = __webpack_public_path__ + "static/media/background3.837c6438.png";